import React from 'react';
import { SvgIconProps } from '@mui/material';

export const NoTasksIconBig: React.FC<SvgIconProps> = (props) => (
    <svg
        width="72"
        height="112"
        viewBox="0 0 72 112"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M18 40C19.1046 40 20 39.1046 20 38C20 36.8954 19.1046 36 18 36C16.8954 36 16 36.8954 16 38C16 39.1046 16.8954 40 18 40Z"
            fill="currentColor"
        />
        <path
            d="M18 52C19.1046 52 20 51.1046 20 50C20 48.8954 19.1046 48 18 48C16.8954 48 16 48.8954 16 50C16 51.1046 16.8954 52 18 52Z"
            fill="currentColor"
        />
        <path
            d="M18 64C19.1046 64 20 63.1046 20 62C20 60.8954 19.1046 60 18 60C16.8954 60 16 60.8954 16 62C16 63.1046 16.8954 64 18 64Z"
            fill="currentColor"
        />
        <path
            d="M18 76C19.1046 76 20 75.1046 20 74C20 72.8954 19.1046 72 18 72C16.8954 72 16 72.8954 16 74C16 75.1046 16.8954 76 18 76Z"
            fill="currentColor"
        />
        <path
            d="M54 40H26C24.896 40 24 39.104 24 38C24 36.896 24.896 36 26 36H54C55.104 36 56 36.896 56 38C56 39.104 55.104 40 54 40Z"
            fill="currentColor"
        />
        <path
            d="M54 52H26C24.896 52 24 51.104 24 50C24 48.896 24.896 48 26 48H54C55.104 48 56 48.896 56 50C56 51.104 55.104 52 54 52Z"
            fill="currentColor"
        />
        <path
            d="M54 64H26C24.896 64 24 63.104 24 62C24 60.896 24.896 60 26 60H54C55.104 60 56 60.896 56 62C56 63.104 55.104 64 54 64Z"
            fill="currentColor"
        />
        <path
            d="M54 76H26C24.896 76 24 75.104 24 74C24 72.896 24.896 72 26 72H54C55.104 72 56 72.896 56 74C56 75.104 55.104 76 54 76Z"
            fill="currentColor"
        />
        <path
            d="M66 112H6C2.692 112 0 109.308 0 106V6C0 2.692 2.692 0 6 0H10C11.104 0 12 0.896 12 2C12 3.104 11.104 4 10 4H6C4.896 4 4 4.9 4 6V106C4 107.1 4.896 108 6 108H66C67.104 108 68 107.1 68 106V6C68 4.9 67.104 4 66 4H22C20.896 4 20 3.104 20 2C20 0.896 20.896 0 22 0H66C69.308 0 72 2.692 72 6V106C72 109.308 69.308 112 66 112Z"
            fill="currentColor"
        />
        <path
            d="M18 40C19.1046 40 20 39.1046 20 38C20 36.8954 19.1046 36 18 36C16.8954 36 16 36.8954 16 38C16 39.1046 16.8954 40 18 40Z"
            fill="currentColor"
        />
        <path
            d="M18 52C19.1046 52 20 51.1046 20 50C20 48.8954 19.1046 48 18 48C16.8954 48 16 48.8954 16 50C16 51.1046 16.8954 52 18 52Z"
            fill="currentColor"
        />
        <path
            d="M18 64C19.1046 64 20 63.1046 20 62C20 60.8954 19.1046 60 18 60C16.8954 60 16 60.8954 16 62C16 63.1046 16.8954 64 18 64Z"
            fill="currentColor"
        />
        <path
            d="M18 76C19.1046 76 20 75.1046 20 74C20 72.8954 19.1046 72 18 72C16.8954 72 16 72.8954 16 74C16 75.1046 16.8954 76 18 76Z"
            fill="currentColor"
        />
        <path
            d="M54 40H26C24.896 40 24 39.104 24 38C24 36.896 24.896 36 26 36H54C55.104 36 56 36.896 56 38C56 39.104 55.104 40 54 40Z"
            fill="currentColor"
        />
        <path
            d="M54 52H26C24.896 52 24 51.104 24 50C24 48.896 24.896 48 26 48H54C55.104 48 56 48.896 56 50C56 51.104 55.104 52 54 52Z"
            fill="currentColor"
        />
        <path
            d="M54 64H26C24.896 64 24 63.104 24 62C24 60.896 24.896 60 26 60H54C55.104 60 56 60.896 56 62C56 63.104 55.104 64 54 64Z"
            fill="currentColor"
        />
        <path
            d="M54 76H26C24.896 76 24 75.104 24 74C24 72.896 24.896 72 26 72H54C55.104 72 56 72.896 56 74C56 75.104 55.104 76 54 76Z"
            fill="currentColor"
        />
        <path
            d="M66 112H6C2.692 112 0 109.308 0 106V6C0 2.692 2.692 0 6 0H10C11.104 0 12 0.896 12 2C12 3.104 11.104 4 10 4H6C4.896 4 4 4.9 4 6V106C4 107.1 4.896 108 6 108H66C67.104 108 68 107.1 68 106V6C68 4.9 67.104 4 66 4H22C20.896 4 20 3.104 20 2C20 0.896 20.896 0 22 0H66C69.308 0 72 2.692 72 6V106C72 109.308 69.308 112 66 112Z"
            fill="currentColor"
        />
    </svg>
);

export default NoTasksIconBig;
